var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import '@mui/material/styles';
import '@mui/material/Typography';
var displaySizeTypographyMap = {
    '2xl': {
        fontSize: '4.5rem',
        lineHeight: '5.625rem',
        letterSpacing: "".concat(4.5 * (-2 / 100), "rem"),
    },
    xl: {
        fontSize: '3.75rem',
        lineHeight: '4.5rem',
        letterSpacing: "".concat(3.75 * (-2 / 100), "rem"),
    },
    lg: {
        fontSize: '3rem',
        lineHeight: '3.75rem',
        letterSpacing: "".concat(3 * (-2 / 100), "rem"),
    },
    md: {
        fontSize: '2.25rem',
        lineHeight: '2.75rem',
        letterSpacing: "".concat(2.25 * (-2 / 100), "rem"),
    },
    sm: {
        fontSize: '1.875rem',
        lineHeight: '2.375rem',
        letterSpacing: '0',
    },
    xs: {
        fontSize: '24px',
        lineHeight: '32px',
        letterSpacing: '0',
    },
};
var textSizeTypographyMap = {
    xl: {
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        letterSpacing: '0',
    },
    lg: {
        fontSize: '1.125rem',
        lineHeight: '1.5rem',
        letterSpacing: '0',
    },
    md: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0',
    },
    sm: {
        fontSize: '.875rem',
        lineHeight: '1.25rem',
        letterSpacing: '0',
    },
    xs: {
        fontSize: '.75rem',
        lineHeight: '1.125rem',
        letterSpacing: '0',
    },
};
var FONT_WEIGHTS = {
    REGULAR: '400',
    MEDIUM: '500',
    SEMIBOLD: '600',
    BOLD: '800',
};
export var TYPOGRAPHY_VARIANTS = {
    'display-2xl-regular': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-2xl-medium': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-2xl-semibold': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-2xl-bold': __assign(__assign({}, displaySizeTypographyMap['2xl']), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-xl-regular': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-xl-medium': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-xl-semibold': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-xl-bold': __assign(__assign({}, displaySizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-lg-regular': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-lg-medium': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-lg-semibold': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-lg-bold': __assign(__assign({}, displaySizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-md-regular': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-md-medium': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-md-semibold': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-md-bold': __assign(__assign({}, displaySizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-sm-regular': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-sm-medium': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-sm-semibold': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-sm-bold': __assign(__assign({}, displaySizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.BOLD }),
    'display-xs-regular': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'display-xs-medium': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'display-xs-semibold': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'display-xs-bold': __assign(__assign({}, displaySizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-xl-regular': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-xl-medium': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-xl-semibold': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-xl-bold': __assign(__assign({}, textSizeTypographyMap.xl), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-lg-regular': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-lg-medium': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-lg-semibold': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-lg-bold': __assign(__assign({}, textSizeTypographyMap.lg), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-md-regular': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-md-medium': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-md-semibold': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-md-bold': __assign(__assign({}, textSizeTypographyMap.md), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-sm-regular': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-sm-medium': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-sm-semibold': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-sm-bold': __assign(__assign({}, textSizeTypographyMap.sm), { fontWeight: FONT_WEIGHTS.BOLD }),
    'text-xs-regular': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.REGULAR }),
    'text-xs-medium': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.MEDIUM }),
    'text-xs-semibold': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.SEMIBOLD }),
    'text-xs-bold': __assign(__assign({}, textSizeTypographyMap.xs), { fontWeight: FONT_WEIGHTS.BOLD }),
};
export var TYPOGRAPHY_VARIANTS_MAPPING = {
    'display-2xl-bold': 'h1',
    'display-2xl-semibold': 'h1',
    'display-2xl-medium': 'h1',
    'display-2xl-regular': 'h1',
    'display-xl-bold': 'h2',
    'display-xl-semibold': 'h2',
    'display-xl-medium': 'h2',
    'display-xl-regular': 'h2',
    'display-lg-bold': 'h3',
    'display-lg-semibold': 'h3',
    'display-lg-medium': 'h3',
    'display-lg-regular': 'h3',
    'display-md-bold': 'h4',
    'display-md-semibold': 'h4',
    'display-md-medium': 'h4',
    'display-md-regular': 'h4',
    'display-sm-bold': 'h5',
    'display-sm-semibold': 'h5',
    'display-sm-medium': 'h5',
    'display-sm-regular': 'h5',
    'display-xs-bold': 'h6',
    'display-xs-semibold': 'h6',
    'display-xs-medium': 'h6',
    'display-xs-regular': 'h6',
    'text-xl-regular': 'p',
    'text-xl-semibold': 'p',
    'text-xl-medium': 'p',
    'text-xl-bold': 'p',
    'text-lg-regular': 'p',
    'text-lg-semibold': 'p',
    'text-lg-medium': 'p',
    'text-lg-bold': 'p',
    'text-md-regular': 'p',
    'text-md-semibold': 'p',
    'text-md-medium': 'p',
    'text-md-bold': 'p',
    'text-sm-regular': 'p',
    'text-sm-semibold': 'p',
    'text-sm-medium': 'p',
    'text-sm-bold': 'p',
    'text-xs-regular': 'p',
    'text-xs-semibold': 'p',
    'text-xs-medium': 'p',
    'text-xs-bold': 'p',
};
